export default __webpack_public_path__ + "static/media/cart.2e696bf1.svg";